import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-900 bg-[#050505] pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-4">
            <div className="flex items-center gap-4 mb-4">
              <img src="/brand/molecularix-logo.webp" alt="Molecularix Biolabs — owl and DNA emblem" className="w-64 md:w-72 h-auto mix-blend-screen" data-testid="footer-brand-logo" />
            </div>
            <p className="text-[#A1A1AA] text-sm mt-4 max-w-sm leading-relaxed">
              Reference-grade research compounds, characterized and prepared for the laboratory. Precision is not optional.
            </p>
            <p className="text-[#52525B] text-xs mt-5 leading-relaxed">Molecularix Biolabs LLC<br />205 Carpenter Street, Muncy, PA 17756<br />MolecularixBiolabs@gmail.com</p>
          </div>
          <div className="md:col-span-2 md:col-start-6">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#52525B] mb-5">Research</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">Catalog</Link></li>
              <li><Link to="/library" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-library">Research Library</Link></li>
              <li><Link to="/documentation" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-documentation">Documentation</Link></li>
              <li><Link to="/verify" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-verify">Verify a Batch</Link></li>
              <li><Link to="/standards" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-standards">Our Standards</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#52525B] mb-5">Support</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/faq" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">FAQ</Link></li>
              <li><Link to="/track" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">Track Order</Link></li>
              <li><Link to="/policy/shipping" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-shipping">Shipping</Link></li>
              <li><Link to="/contact" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#52525B] mb-5">Company</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-about">About</Link></li>
              <li><Link to="/ambassador" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">Partner Program</Link></li>
              <li><Link to="/policy/research-use" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-ruo">Research Use Only</Link></li>
              <li><Link to="/policy/terms" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-terms">Terms</Link></li>
              <li><Link to="/policy/privacy" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-privacy">Privacy</Link></li>
              <li><Link to="/policy/refunds" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="footer-refunds">Refunds</Link></li>
            </ul>
          </div>
        </div>

        {/* Elite ambassador portal */}
        <div className="border-t border-zinc-900 pt-10 pb-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-2">Molecularix Elite</p>
            <p className="text-[#A1A1AA] text-sm max-w-md leading-relaxed">Our invitation-only ambassador circle. Members earn commissions and unlock exclusive resources.</p>
          </div>
          <Link to="/ambassador?view=login" data-testid="footer-ambassador-login"
            className="group relative inline-flex items-center gap-3 shrink-0 border border-[#D4AF37]/40 hover:border-[#D4AF37] bg-[#D4AF37]/[0.04] hover:bg-[#D4AF37]/[0.08] px-6 py-4 transition-colors duration-300 overflow-hidden">
            <Sparkles size={15} className="text-[#D4AF37]" />
            <span className="flex flex-col leading-tight">
              <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-[#71717A] group-hover:text-[#A1A1AA] transition-colors">Ambassadors</span>
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#E8E8E3]">Sign in to your portal</span>
            </span>
            <ArrowRight size={15} className="text-[#D4AF37] transition-transform duration-300 group-hover:translate-x-1.5" />
          </Link>
        </div>

        <div className="border-t border-zinc-900 mt-8 pt-8 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-[#52525B] text-xs font-mono">© {new Date().getFullYear()} Molecularix Biolabs</p>
          <p className="text-[#52525B] text-xs font-mono uppercase tracking-wider">For research use only · Not for human consumption</p>
        </div>
      </div>
    </footer>
  );
}
